<template>
  <div class="view-container">
    <!-- 搜索筛选栏 -->
    <div class="search-panel">
      <div class="search-row">
        <div class="search-item">
          <label><i class="fas fa-search"></i> 作业名称</label>
          <input v-model="searchForm.keyword" type="text" placeholder="请输入作业名称" class="search-input">
        </div>
        <div class="search-item">
          <label><i class="fas fa-tag"></i> 执行类型</label>
          <select v-model="searchForm.jobType" class="search-select">
            <option value="">全部</option>
            <option value="1">SQL脚本</option>
            <option value="2">HTTP请求</option>
            <option value="3">自定义脚本</option>
          </select>
        </div>
        <div class="search-item">
          <label><i class="fas fa-toggle-on"></i> 状态</label>
          <select v-model="searchForm.status" class="search-select">
            <option value="">全部</option>
            <option value="1">运行中</option>
            <option value="0">已停止</option>
          </select>
        </div>
        <div class="search-actions">
          <button @click="handleSearch" class="btn btn-primary search-btn">
            <i class="fas fa-search"></i> 查询
          </button>
          <button @click="resetSearch" class="btn btn-default search-btn">
            <i class="fas fa-undo"></i> 重置
          </button>
        </div>
      </div>
    </div>

    <!-- 作业表格 -->
    <div class="table-wrapper">
      <div class="table-header-row">
        <button @click="openAddJob" class="btn btn-primary btn-sm">
          <i class="fas fa-plus"></i> 新增作业
        </button>
      </div>
      
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th style="width:50px">序号</th>
              <th>作业名称</th>
              <th style="width:90px">执行类型</th>
              <th style="width:130px">Cron表达式</th>
              <th style="width:70px">状态</th>
              <th style="width:150px">上次执行</th>
              <th style="width:150px">下次执行</th>
              <th style="width:180px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(job, idx) in jobs" :key="job.guid">
              <td>{{ (currentPage - 1) * pageSize + idx + 1 }}</td>
              <td>
                <div class="job-name-cell">
                  <span class="job-name">{{ job.jobName }}</span>
                  <span class="job-desc">{{ job.description }}</span>
                </div>
              </td>
              <td>
                <span class="type-tag" :class="getTypeClass(job.jobType)">
                  {{ getTypeName(job.jobType) }}
                </span>
              </td>
              <td>
                <code class="cron-code">{{ job.cronExpr || '-' }}</code>
              </td>
              <td>
                <span class="status-badge" :class="getStatusClass(job.status)">
                  {{ getStatusText(job.status) }}
                </span>
              </td>
              <td>{{ formatTime(job.lastRunTime) }}</td>
              <td>{{ job.nextRunTime ? formatTime(job.nextRunTime) : '-' }}</td>
              <td>
                <div class="action-column">
                  <button v-if="job.status === 0" @click="toggleStatus(job)" class="btn btn-success btn-xs" title="启动">
                    <i class="fas fa-play"></i>
                  </button>
                  <button v-else @click="toggleStatus(job)" class="btn btn-warning btn-xs" title="暂停">
                    <i class="fas fa-pause"></i>
                  </button>
                  <button @click="openEditJob(job)" class="btn btn-primary btn-xs" title="编辑">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button @click="delJob(job)" class="btn btn-danger btn-xs" title="删除">
                    <i class="fas fa-trash"></i>
                  </button>
                  <button @click="triggerRun(job)" class="btn btn-info btn-xs" title="测试">
                    <i class="fas fa-flask"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="jobs.length === 0">
              <td colspan="8" class="table-empty">暂无数据</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <div class="pagination-row">
        <div class="pagination-info">
          共 {{ total }} 条记录
        </div>
        <div class="pagination-nav">
          <button class="btn-page" :disabled="currentPage === 1" @click="goPage(currentPage - 1)">
            <i class="fas fa-chevron-left"></i>
          </button>
          <span class="page-current">{{ currentPage }} / {{ totalPages }}</span>
          <button class="btn-page" :disabled="currentPage === totalPages" @click="goPage(currentPage + 1)">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ===== 作业编辑弹窗 ===== -->
    <div v-if="dialog.visible" class="modal-overlay" @click.self="dialog.visible = false">
      <div class="modal-container" style="width:650px">
        <div class="modal-header">
          <h3>{{ dialog.isEdit ? '编辑作业' : '新增作业' }}</h3>
          <button @click="dialog.visible = false" class="close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveJobForm" class="form-horizontal">
            <div class="form-row">
              <div class="form-group">
                <label>作业名称 <span class="req">*</span></label>
                <input v-model="dialog.form.JobName" class="form-control" placeholder="输入作业名称" />
              </div>
              <div class="form-group">
                <label>执行类型 <span class="req">*</span></label>
                <select v-model="dialog.form.JobType" class="form-control" @change="onJobTypeChange">
                  <option :value="1">SQL脚本</option>
                  <option :value="2">HTTP请求</option>
                  <option :value="3">自定义脚本</option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>描述</label>
                <input v-model="dialog.form.Description" class="form-control" placeholder="作业描述" />
              </div>
              <div class="form-group">
                <label>Cron表达式 <span class="req">*</span></label>
                <input v-model="dialog.form.CronExpr" class="form-control" placeholder="如 0 0 2 * * ?" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>生效开始</label>
                <input type="datetime-local" v-model="dialog.form.StartTime" class="form-control" />
              </div>
              <div class="form-group">
                <label>生效结束</label>
                <input type="datetime-local" v-model="dialog.form.EndTime" class="form-control" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group" style="flex:1; max-width:100%">
                <label>备注</label>
                <input v-model="dialog.form.Remark" class="form-control" placeholder="备注" />
              </div>
            </div>

            <!-- SQL 配置 -->
            <template v-if="dialog.form.JobType === 1">
              <div class="section-title">SQL 配置</div>
              <div class="form-row">
                <div class="form-group" style="flex:1; max-width:100%">
                  <label>连接串</label>
                  <input v-model="dialog.form.ConnectionString" class="form-control" placeholder="留空使用默认库连接串" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group" style="flex:1; max-width:100%">
                  <label>SQL语句 <span class="req">*</span></label>
                  <textarea v-model="dialog.form.SqlText" class="form-control" rows="6" placeholder="输入要执行的SQL语句..." style="font-family:Consolas,monospace"></textarea>
                </div>
              </div>
            </template>

            <!-- HTTP 请求配置 -->
            <template v-if="dialog.form.JobType === 2">
              <div class="section-title">HTTP 请求配置</div>
              <div class="form-row">
                <div class="form-group" style="flex:1; max-width:100%">
                  <label>请求URL <span class="req">*</span></label>
                  <input v-model="dialog.form.ApiUrl" class="form-control" placeholder="http://..." />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>请求方式</label>
                  <select v-model="dialog.form.ApiMethod" class="form-control">
                    <option value="GET">GET</option>
                    <option value="POST">POST</option>
                    <option value="PUT">PUT</option>
                    <option value="DELETE">DELETE</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group" style="flex:1; max-width:100%">
                  <label>请求体(JSON)</label>
                  <textarea v-model="dialog.form.ApiBody" class="form-control" rows="4" placeholder='{"key":"value"}' style="font-family:Consolas,monospace"></textarea>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group" style="flex:1; max-width:100%">
                  <label>请求头(JSON)</label>
                  <input v-model="dialog.form.ApiHeaders" class="form-control" placeholder='{"Authorization":"Bearer xxx"}' />
                </div>
              </div>
            </template>

            <!-- 自定义脚本配置 -->
            <template v-if="dialog.form.JobType === 3">
              <div class="section-title">自定义脚本配置</div>
              <div class="form-row">
                <div class="form-group" style="flex:1; max-width:100%">
                  <label>脚本路径 <span class="req">*</span></label>
                  <input v-model="dialog.form.ScriptPath" class="form-control" placeholder="如: scripts/myjob.py" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group" style="flex:1; max-width:100%">
                  <label>脚本参数</label>
                  <input v-model="dialog.form.ScriptArgs" class="form-control" placeholder="脚本执行参数" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group" style="flex:1; max-width:100%">
                  <label>脚本内容</label>
                  <textarea v-model="dialog.form.ScriptContent" class="form-control" rows="6" placeholder="输入脚本内容..." style="font-family:Consolas,monospace"></textarea>
                </div>
              </div>
            </template>
          </form>
        </div>
        <div class="modal-footer">
          <button @click="dialog.visible = false" class="btn btn-default">取消</button>
          <button @click="saveJobForm" class="btn btn-primary">保存</button>
        </div>
      </div>
    </div>

    <!-- ===== 执行日志弹窗 ===== -->
    <div v-if="logDialog.visible" class="modal-overlay" @click.self="logDialog.visible = false">
      <div class="modal-container" style="width:750px">
        <div class="modal-header">
          <h3>执行日志 - {{ logDialog.jobName }}</h3>
          <button @click="logDialog.visible = false" class="close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body log-body">
          <table class="log-table">
            <thead>
              <tr>
                <th style="width:150px">执行时间</th>
                <th style="width:80px">耗时(ms)</th>
                <th style="width:60px">结果</th>
                <th>消息</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logDialog.logs" :key="log.id">
                <td>{{ formatTime(log.runTime) }}</td>
                <td>{{ log.duration }}</td>
                <td><span :class="log.result === 1 ? 'log-ok' : 'log-fail'">{{ log.result === 1 ? '成功' : '失败' }}</span></td>
                <td><div class="log-msg">{{ log.message }}</div></td>
              </tr>
              <tr v-if="logDialog.logs.length === 0">
                <td colspan="4" style="text-align:center;color:#9ca3af;padding:30px">暂无执行记录</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { getJobs, getJobById, saveJob, deleteJob, setJobStatus, triggerJob, getJobLogs } from '../api/job'

const searchForm = reactive({
  keyword: '',
  jobType: '',
  status: ''
})
const currentPage = ref(1)
const pageSize = ref(20)
const total = ref(0)
const totalPages = computed(() => Math.max(1, Math.ceil(total.value / pageSize.value)))
const jobs = ref([])

async function loadJobs() {
  try {
    const params = {
      keyword: searchForm.keyword || undefined,
      jobType: searchForm.jobType !== '' ? parseInt(searchForm.jobType) : undefined,
      status: searchForm.status !== '' ? parseInt(searchForm.status) : undefined,
      page: currentPage.value,
      pageSize: pageSize.value
    }
    const res = await getJobs(params)
    const data = res?.data ?? res?.Data ?? []
    total.value = res?.total ?? res?.Total ?? 0
    jobs.value = Array.isArray(data) ? data : []
  } catch (e) { console.error('Load jobs error:', e) }
}

function handleSearch() { currentPage.value = 1; loadJobs() }
function resetSearch() { searchForm.keyword = ''; searchForm.jobType = ''; searchForm.status = ''; currentPage.value = 1; loadJobs() }
function goPage(page) { if (page < 1 || page > totalPages.value) return; currentPage.value = page; loadJobs() }

const dialog = reactive({ visible: false, isEdit: false, form: emptyJobForm() })

function emptyJobForm() {
  return {
    Guid: '', JobName: '', JobType: 1, Description: '',
    CronExpr: '', StartTime: '', EndTime: '', Remark: '',
    ConnectionString: '', SqlText: '',
    ApiUrl: '', ApiMethod: 'GET', ApiBody: '', ApiHeaders: '',
    ScriptPath: '', ScriptArgs: '', ScriptContent: ''
  }
}

function openAddJob() { dialog.isEdit = false; dialog.form = emptyJobForm(); dialog.visible = true }

function mapJobToForm(job) {
  return {
    Guid: job.guid ?? job.Guid ?? '',
    JobName: job.jobName ?? job.JobName ?? '',
    JobType: job.jobType ?? job.JobType ?? 1,
    Description: job.description ?? job.Description ?? '',
    CronExpr: job.cronExpr ?? job.CronExpr ?? '',
    StartTime: job.startTime ?? job.StartTime ?? '',
    EndTime: job.endTime ?? job.EndTime ?? '',
    Remark: job.remark ?? job.Remark ?? '',
    ConnectionString: job.connectionString ?? job.ConnectionString ?? '',
    SqlText: job.sqlText ?? job.SqlText ?? '',
    ApiUrl: job.apiUrl ?? job.ApiUrl ?? '',
    ApiMethod: job.apiMethod ?? job.ApiMethod ?? 'GET',
    ApiBody: job.apiBody ?? job.ApiBody ?? '',
    ApiHeaders: job.apiHeaders ?? job.ApiHeaders ?? '',
    ScriptPath: job.scriptPath ?? job.ScriptPath ?? '',
    ScriptArgs: job.scriptArgs ?? job.ScriptArgs ?? '',
    ScriptContent: job.scriptContent ?? job.ScriptContent ?? '',
    Status: job.status ?? job.Status ?? 0
  }
}

function openEditJob(job) {
  dialog.isEdit = true; dialog.form = mapJobToForm(job)
  if (dialog.form.StartTime) dialog.form.StartTime = dialog.form.StartTime.slice(0, 16)
  if (dialog.form.EndTime) dialog.form.EndTime = dialog.form.EndTime.slice(0, 16)
  dialog.visible = true
}

function onJobTypeChange() {
  if (dialog.form.JobType !== 1) { dialog.form.ConnectionString = ''; dialog.form.SqlText = '' }
  if (dialog.form.JobType !== 2) { dialog.form.ApiUrl = ''; dialog.form.ApiMethod = 'GET'; dialog.form.ApiBody = ''; dialog.form.ApiHeaders = '' }
  if (dialog.form.JobType !== 3) { dialog.form.ScriptPath = ''; dialog.form.ScriptArgs = ''; dialog.form.ScriptContent = '' }
}

async function saveJobForm() {
  const f = dialog.form
  if (!f.JobName.trim()) return $message.warning('请输入作业名称')
  if (!f.CronExpr.trim()) return $message.warning('请输入Cron表达式')
  if (f.JobType === 1 && !f.SqlText?.trim()) return $message.warning('请输入SQL语句')
  if (f.JobType === 2 && !f.ApiUrl?.trim()) return $message.warning('请输入请求URL')
  if (f.JobType === 3 && !f.ScriptPath?.trim()) return $message.warning('请输入脚本路径')
  try { await saveJob(f); dialog.visible = false; loadJobs() } catch (e) { $message.error('保存失败: ' + e.message) }
}

async function delJob(job) {
  const name = job.jobName ?? job.JobName ?? ''
  if (!await $confirm(`确定删除作业 "${name}"？`)) return
  const guid = job.guid ?? job.Guid ?? ''
  try { await deleteJob(guid); loadJobs() } catch (e) { $message.error('删除失败: ' + e.message) }
}

async function toggleStatus(job) {
  const guid = job.guid ?? job.Guid ?? ''
  const curStatus = job.status ?? job.Status ?? 0
  const newStatus = curStatus === 1 ? 0 : 1
  try { await setJobStatus(guid, newStatus); if (typeof job.status !== 'undefined') job.status = newStatus; else job.Status = newStatus } catch (e) { $message.error('操作失败: ' + e.message) }
}

async function triggerRun(job) {
  const name = job.jobName ?? job.JobName ?? ''
  if (!await $confirm(`确定测试执行作业 "${name}"？`)) return
  const guid = job.guid ?? job.Guid ?? ''
  try { await triggerJob(guid); $message.success('已触发，即将执行'); setTimeout(loadJobs, 2000) } catch (e) { $message.error('触发失败: ' + e.message) }
}

const logDialog = reactive({ visible: false, jobName: '', logs: [] })

async function openLogs(job) {
  logDialog.jobName = job.jobName ?? job.JobName ?? ''; logDialog.visible = true
  const guid = job.guid ?? job.Guid ?? ''
  try { const res = await getJobLogs(guid); const data = res?.data ?? res?.Data ?? []; logDialog.logs = Array.isArray(data) ? data : [] } catch (e) { logDialog.logs = []; console.error(e) }
}

function getTypeName(type) { const map = { 1: 'SQL脚本', 2: 'HTTP请求', 3: '自定义脚本' }; return map[type] || '未知' }
function getTypeClass(type) { const map = { 1: 'type-sql', 2: 'type-http', 3: 'type-custom' }; return map[type] || '' }
function getStatusText(status) { return status === 1 ? '运行中' : '已停止' }
function getStatusClass(status) { return status === 1 ? 'valid' : 'disabled' }

function formatTime(t) {
  if (!t) return '-'
  try { const d = new Date(t); if (isNaN(d.getTime())) return t.slice(0, 19).replace('T', ' '); return d.toLocaleString('zh-CN', { hour12: false }) } catch { return t }
}

onMounted(loadJobs)
</script>

<style scoped>
.view-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 150px);
  overflow: hidden;
}

/* Buttons */
.btn {
  padding: 6px 15px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s ease;
}
.btn-primary { background-color: #1ab394; color: #fff; }
.btn-primary:hover { background-color: #18a689; }
.btn-default { background-color: #f3f3f4; color: #676a6c; border: 1px solid #e7eaec; }
.btn-default:hover { background-color: #e7eaec; }
.btn-info { background-color: #31b0d5; color: #fff; }
.btn-info:hover { background-color: #269abc; }
.btn-warning { background-color: #f0ad4e; color: #fff; }
.btn-warning:hover { background-color: #ec971f; }
.btn-danger { background-color: #d9534f; color: #fff; }
.btn-danger:hover { background-color: #c9302c; }
.btn-success { background-color: #5cb85c; color: #fff; }
.btn-success:hover { background-color: #4cae4c; }
.btn-xs { padding: 3px 8px; font-size: 12px; margin-right: 3px; }
.btn-sm { padding: 5px 12px; font-size: 12px; }

/* Search */
.search-panel {
  background: #fff;
  border: 1px solid #e0e4e8;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.search-row { display: flex; flex-wrap: wrap; gap: 16px; align-items: flex-end; }
.search-item { display: flex; align-items: center; gap: 8px; white-space: nowrap; }
.search-item label { font-size: 13px; color: #6b7280; font-weight: 500; }
.search-item label i { margin-right: 2px; color: #1ab394; font-size: 12px; }
.search-input {
  padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px;
  width: 160px; outline: none; transition: border-color 0.2s, box-shadow 0.2s; background: #fafbfc;
}
.search-input:focus { border-color: #1ab394; box-shadow: 0 0 0 3px rgba(26,179,148,0.12); background: #fff; }
.search-select {
  padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px;
  width: 130px; outline: none; background: #fafbfc; cursor: pointer; transition: border-color 0.2s, box-shadow 0.2s; appearance: auto;
}
.search-select:focus { border-color: #1ab394; box-shadow: 0 0 0 3px rgba(26,179,148,0.12); background: #fff; }
.search-actions { display: flex; gap: 10px; margin-left: auto; align-self: flex-end; }
.search-btn { padding: 8px 18px; font-size: 13px; border-radius: 6px; font-weight: 500; }

/* Table */
.table-wrapper {
  border: 1px solid #e7eaec; border-radius: 4px; overflow: hidden;
  display: flex; flex-direction: column; flex: 1; min-height: 0;
}
.table-header-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 10px 15px; background-color: #f9f9f9; border-bottom: 1px solid #e7eaec; flex-shrink: 0;
}
.table-container { overflow-y: auto; flex: 1; min-height: 0; }
.data-table { width: 100%; border-collapse: collapse; }
.data-table th, .data-table td { padding: 10px 15px; text-align: left; border-bottom: 1px solid #e7eaec; white-space: nowrap; }
.data-table th {
  background-color: #f5f5f5; font-weight: 600; color: #676a6c; font-size: 13px;
  position: sticky; top: 0; z-index: 2;
}
.data-table td { font-size: 13px; color: #676a6c; }
.data-table tbody tr:hover { background-color: #f9f9f9; }
.table-empty { text-align: center; color: #9ca3af; padding: 40px !important; }

/* Job name cell */
.job-name-cell { display: flex; flex-direction: column; gap: 2px; }
.job-name { font-weight: 600; color: #3a4a63; }
.job-desc { font-size: 12px; color: #9ca3af; }

/* Type tag */
.type-tag { padding: 2px 8px; border-radius: 3px; font-size: 12px; font-weight: 500; }
.type-sql { background-color: #d4edda; color: #155724; }
.type-http { background-color: #d1ecf1; color: #0c5460; }
.type-custom { background-color: #fff3cd; color: #856404; }

/* Cron */
.cron-code { font-family: Consolas, monospace; font-size: 12px; color: #676a6c; }

/* Status */
.status-badge { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 12px; font-weight: 500; }
.status-badge.valid { background-color: #d4edda; color: #155724; }
.status-badge.disabled { background-color: #f8d7da; color: #721c24; }

/* Action column */
.action-column { white-space: nowrap; }

/* Pagination */
.pagination-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 12px 15px; background-color: #f9f9f9; border-top: 1px solid #e7eaec; flex-shrink: 0;
}
.pagination-info { font-size: 13px; color: #676a6c; }
.pagination-nav { display: flex; align-items: center; gap: 8px; }
.btn-page {
  width: 32px; height: 32px; border: 1px solid #e7eaec; background-color: #fff;
  color: #676a6c; border-radius: 4px; cursor: pointer; font-size: 13px;
  display: flex; align-items: center; justify-content: center; transition: all 0.2s ease;
}
.btn-page:hover:not(:disabled) { background-color: #f9f9f9; border-color: #1ab394; color: #1ab394; }
.btn-page:disabled { opacity: 0.5; cursor: not-allowed; }
.page-current { font-size: 13px; color: #676a6c; min-width: 80px; text-align: center; }

/* Modal */
.modal-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); display: flex; align-items: center; justify-content: center; z-index: 1000;
}
.modal-container { background-color: #fff; border-radius: 6px; max-height: 90vh; overflow: hidden; display: flex; flex-direction: column; }
.modal-header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 15px 20px; border-bottom: 1px solid #e7eaec;
}
.modal-header h3 { margin: 0; font-size: 16px; color: #3a4a63; }
.close-btn { background: none; border: none; cursor: pointer; color: #676a6c; font-size: 16px; }
.close-btn:hover { color: #333; }
.modal-body { padding: 20px; max-height: calc(90vh - 140px); overflow-y: auto; overflow-x: hidden; }
.modal-footer { display: flex; justify-content: flex-end; gap: 10px; padding: 15px 20px; border-top: 1px solid #e7eaec; }

.form-horizontal { display: flex; flex-direction: column; gap: 15px; }
.form-row { display: flex; gap: 15px; flex-wrap: wrap; }
.form-group { display: flex; flex-direction: column; flex: 1; min-width: 180px; max-width: 250px; }
.form-group label { font-size: 13px; color: #676a6c; margin-bottom: 5px; font-weight: 500; }
.form-group .form-control { padding: 8px 12px; border: 1px solid #e7eaec; border-radius: 4px; font-size: 13px; }
.form-group .form-control:disabled { background-color: #f3f3f4; cursor: not-allowed; }
.req { color: #d9534f; }
.section-title { padding: 10px 0 6px 0; font-size: 14px; font-weight: 600; color: #3a4a63; border-bottom: 1px solid #e7eaec; margin: 10px 0 5px 0; }

/* Log table */
.log-body { max-height: 500px; }
.log-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.log-table th { background: #f5f5f5; border-bottom: 1px solid #e7eaec; padding: 8px 12px; text-align: left; font-weight: 600; color: #676a6c; }
.log-table td { padding: 8px 12px; border-bottom: 1px solid #e7eaec; color: #676a6c; }
.log-table tbody tr:hover { background: #f9f9f9; }
.log-ok { color: #155724; font-weight: 600; }
.log-fail { color: #721c24; font-weight: 600; }
.log-msg { max-width: 350px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
</style>
